module.exports = __webpack_public_path__ + "static/media/shirley.51ca963a.jpg";